import * as React from "react";
import * as ReactDOM from "react-dom";
import Slider from "react-slick";
import Ajax from "../../Ajax";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

interface IFormProps {
  gallery
}
interface MyStates {
 gallery:object,
 ajaxLoaded: boolean,
 current: string
 
}
export default class Gallery extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = { 
      gallery: {},
      ajaxLoaded: false,
      current: ''
    } 

    this.getData();

  }


  private getData() {
    var ajax = new Ajax(window.location.origin+ '/api/ordering/loadgallery/' + this.props.gallery);
    ajax.doPost({}).then((response) => {
      this.setState({
        gallery: response.data,
        ajaxLoaded: true
      })
    })
  }

  handleClickImage = (e, image) => {
    e && e.preventDefault();
 
    this.setState({
      current: image
    })
   }

 
  
  render() {
    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: Object.keys(this.state.gallery).length < 3 ? Object.keys(this.state.gallery).length : 3,
      slidesToScroll: 1,
      speed: 1000,
      cssEase: "linear",

    };
    
    if( this.state.ajaxLoaded ){
     
    return (
      
      <div>
        <Slider {...settings}>
        {
        Object.keys(this.state.gallery).map((i) => (
          <div key = {i}>
            <img onClick={ e => this.handleClickImage(e, '/'+this.state.gallery[i].image)} style ={{'width': '100%', 'paddingRight': '10px','paddingLeft': '10px', 'maxWidth': '500px', 'margin': 'auto', 'cursor': 'pointer'}} src = {'/'+this.state.gallery[i].image} />
          </div> 
        ))
        }
        </Slider>
        {this.state.current &&
         <Lightbox
            mainSrc={this.state.current}
            onCloseRequest={() => this.setState({ current: '' })}
            />
      }
      </div>
    );
    }
    else {
      return (<>Betöltés</>)
    }
  }
}

export class InitGallery {
  constructor() {
      var div: HTMLDivElement = document.getElementById('slider_app') as HTMLDivElement;
      if (div !== null) {
          var data:any = div.dataset;
          ReactDOM.render(<Gallery gallery={data.gallery}/>, div);
      }
  }
}